"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

var _Image = _interopRequireDefault(require("../Image/Image"));

var _Text = _interopRequireDefault(require("../Text/Text"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Footer = function Footer(_ref) {
  var title = _ref.title,
      logoUrl = _ref.logoUrl,
      logoAlt = _ref.logoAlt,
      showPoweredBy = _ref.showPoweredBy,
      links = _ref.links,
      variant = _ref.variant,
      props = _objectWithoutPropertiesLoose(_ref, ["title", "logoUrl", "logoAlt", "showPoweredBy", "links", "variant"]);

  return (0, _themeUi.jsx)("footer", _extends({}, props, {
    sx: {
      height: [8, 10],
      width: '100%',
      position: 'relative',
      overflow: 'hidden',
      py: [1, 5]
    }
  }), (0, _themeUi.jsx)("div", {
    sx: _extends({
      position: 'absolute',
      top: 0,
      left: '50%',
      height: '100%',
      width: '120%',
      borderRadius: '50% 50% 0 0',
      transform: 'translateX(-50%)',
      overflow: 'hidden',
      py: [1, 5]
    }, variant === 'dark' && {
      ':before': {
        content: "''",
        position: 'absolute',
        opacity: 1,
        left: 0,
        right: 0,
        bottom: 0,
        top: 0,
        backgroundImage: "url('https://media.versoapp.com/Images/textures/connectwork.png')",
        zIndex: -1
      },
      ':after': {
        content: "''",
        position: 'absolute',
        bg: 'primaryDark',
        opacity: 0.6,
        left: 0,
        right: 0,
        bottom: 0,
        top: 0,
        zIndex: -1
      }
    })
  }, logoUrl && (0, _themeUi.jsx)(_themeUi.Flex, {
    sx: {
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      pb: 4
    }
  }, (0, _themeUi.jsx)(_Image["default"], {
    src: logoUrl,
    alt: logoAlt,
    sx: {
      maxHeight: [7, 9],
      maxWidth: 12,
      height: 'auto'
    }
  }))), (0, _themeUi.jsx)(_themeUi.Flex, {
    sx: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      p: [3, 5],
      width: '100%',
      justifyContent: ['center', 'space-between'],
      alignItems: 'flex-end'
    }
  }, (0, _themeUi.jsx)(_themeUi.Box, null, title && (0, _themeUi.jsx)(_Text["default"], {
    variant: "subtitle",
    sx: {
      color: variant === 'dark' ? 'textWhite' : 'text',
      display: ['none', 'block']
    }
  }, title), links && (0, _themeUi.jsx)(_Text["default"], {
    variant: "caption",
    sx: {
      color: variant === 'dark' ? 'textWhite' : 'text',
      display: 'block'
    }
  }, links && links.map(function (link) {
    return (0, _themeUi.jsx)("a", {
      key: link.label,
      href: link.url,
      sx: {
        mr: 2,
        textDecoration: 'underline',
        color: 'inherit'
      }
    }, link.label);
  }))), showPoweredBy ? (0, _themeUi.jsx)(_themeUi.Flex, {
    sx: {
      alignItems: 'flex-end',
      display: ['none', 'flex']
    }
  }, (0, _themeUi.jsx)(_Text["default"], {
    variant: "caption",
    sx: {
      color: variant === 'dark' ? 'white' : 'text',
      mr: 2
    }
  }, "Powered by"), (0, _themeUi.jsx)(_Image["default"], {
    src: variant === 'dark' ? 'https://media.versoapp.com/Brand/Verso/Logo/Mini/Light.svg' : 'https://media.versoapp.com/Brand/Verso/Logo/Mini/Dark.svg',
    alt: "Verso"
  })) : (0, _themeUi.jsx)(_themeUi.Flex, {
    sx: {
      alignItems: 'flex-end',
      display: ['none', 'flex']
    }
  }, (0, _themeUi.jsx)(_Text["default"], {
    variant: "caption",
    sx: {
      color: variant === 'dark' ? 'white' : 'text',
      mr: 2
    }
  }, "Proudly supported by"), (0, _themeUi.jsx)(_Image["default"], {
    sx: {
      height: 3
    },
    src: variant === 'dark' ? 'https://media.versoapp.com/Brand/Verso/VicSRC_logo_simple_light.svg' : 'https://media.versoapp.com/Brand/Verso/VicSRC_logo_simple_light.svg',
    alt: "Vic SRC"
  }))));
};

Footer.propTypes = {
  title: _propTypes["default"].string,
  logoUrl: _propTypes["default"].string,
  logoAlt: _propTypes["default"].string,
  showPoweredBy: _propTypes["default"].bool,
  links: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    url: _propTypes["default"].string
  })),
  variant: _propTypes["default"].oneOf(['light', 'dark'])
};
Footer.defaultProps = {
  title: null,
  logoUrl: null,
  logoAlt: null,
  showPoweredBy: false,
  links: null,
  variant: 'dark'
};
var _default = Footer;
exports["default"] = _default;